(() => {
 const lote = window.__PRODUCT_LOTE__;
  if (!lote) return;

  function inject(body) {
    try {
      // FormData (forms)
      if (body instanceof FormData) {
        body.set("properties[_Lote]", lote);
        return body;
      }

      // URLSearchParams
      if (body instanceof URLSearchParams) {
        body.set("properties[_Lote]", lote);
        return body;
      }

      // String: JSON o x-www-form-urlencoded
      if (typeof body === "string") {
        const t = body.trim();

        // JSON
        if (t.startsWith("{") || t.startsWith("[")) {
          const obj = JSON.parse(body);

          // Caso: { items: [ {id, quantity, properties} ] }
          if (obj && Array.isArray(obj.items)) {
            obj.items = obj.items.map((it) => {
              it.properties = it.properties || {};
              it.properties._Lote = lote;
              return it;
            });
          } else {
            // Caso: item simple
            obj.properties = obj.properties || {};
            obj.properties._Lote = lote;
          }

          return JSON.stringify(obj);
        }

        // x-www-form-urlencoded
        const params = new URLSearchParams(body);
        params.set("properties[_Lote]", lote);
        return params.toString();
      }
    } catch (e) {
      // Si falla, devolvemos el body original
    }
    return body;
  }

  // Interceptar fetch
  const _fetch = window.fetch;
  window.fetch = function (input, init = {}) {
    const url = typeof input === "string" ? input : input?.url;
    const method = (init?.method || "GET").toUpperCase();

    if (url && (url.includes("/cart/add") || url.includes("/cart/add.js")) && method === "POST") {
      const newInit = { ...init };
      newInit.body = inject(init.body);
      return _fetch(input, newInit);
    }
    return _fetch(input, init);
  };

  // Interceptar XHR (por si Globo usa $.ajax)
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__isCartAdd = typeof url === "string" && (url.includes("/cart/add") || url.includes("/cart/add.js"));
    this.__method = (method || "GET").toUpperCase();
    return _open.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this.__isCartAdd && this.__method === "POST") {
      body = inject(body);
    }
    return _send.call(this, body);
  };
})();